<script>
import TabPane from 'element-ui/lib/tab-pane';

export default TabPane;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/tab-pane.css';
</style>
